import { render, staticRenderFns } from "./Height.vue?vue&type=template&id=850583d6&"
import script from "./Height.vue?vue&type=script&lang=ts&"
export * from "./Height.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports